import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { useNavigate } from "react-router-dom"
import { useQsFilters } from "../../hooks/filters"
import { useMediaList } from "../../hooks/media"
import { TableMedia } from "./TableMedia"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
  } as FiltersBase)

export default function Media() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useMediaList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Media" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>
            Media
          </H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/media/media/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value , page: 1 })
            }}
          />
        </Flex>
        <TableMedia
          media={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
